<template>
    <el-row>
      <el-col :span="24">

        <br />

        <h2>Sharers Summary</h2>
        <sharers-bar-chart v-if="sharers.length >= 0" :sharer-data="sharers" />

        <data-table
          table-ref="sharingtable"

          title=""
          title-heading="h2"
          icon="fa fa-users"

          url="stats/org/20/null/telco"

          sort-field="sitesTotal"
          sort-direction="desc"
          :show-search="false"

          :hide-org-badge="hideOrgBadge"
          :title-class="titleClass"

          :fields="fields"

          stripe

          track-by="organisation_id">

          <template slot="details" slot-scope="scope">
            <popup-sharer-stats :row-data="scope.rowData" />
          </template>

        </data-table>

    </el-col>
  </el-row>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'

import SharersBarChart from '@/components/dashboard/charts/SharersBarChart'
import PopupSharerStats from '@/components/dashboard/sharers/PopupSharerStats'


export default {

  mixins: [PostMixins],

  components: {
    PopupSharerStats,
    SharersBarChart
  },



  props: {

    hideOrgBadge: {
      type: Boolean,
      default: false
    },

    titleClass: {
      type: String,
      default: null
    }

  },


  methods: {

    processData(data) {
      this.sharers = data
    }

  },


  data () {
    return {
      sharers: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          title: 'Name',
          name: 'shortName'
        },
        {
          title: 'Total',
          name: 'sitesTotal',
          titleClass: 'text-black',
          dataClass: 'text-black'
        },
        {
          title: '% sites',
          name: 'percentSites',
          titleClass: 'hidden-sm-and-down text-info',
          dataClass: 'hidden-sm-and-down text-center text-info'
        },
        {
          title: 'Active',
          name: 'sitesActive',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-center text-primary'
        },
        {
          title: 'New',
          name: 'sitesNew',
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-center text-success'
        },
        {
          title: 'Exclusive',
          name: 'sitesExclusive',
          titleClass: 'hidden-md-and-down text-black',
          dataClass: 'hidden-md-and-down text-center text-black'
        },
        {
          title: 'Canditate',
          name: 'sitesCanditate',
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-center text-warning'
        },
        {
          title: 'Dismantled',
          name: 'sitesDismantled',
          titleClass: 'hidden-md-and-down text-danger',
          dataClass: 'hidden-md-and-down text-center text-danger'
        },
        {
          title: 'Temporary',
          name: 'sitesTemporary',
          titleClass: 'hidden-md-and-down text-info',
          dataClass: 'hidden-md-and-down text-center'
        },
        {
          title: 'Ratio %',
          name: 'sharingRatio',
          sortField: 'sharingRatio'
        },
        {
          name: '__slot:details'
        }
      ]
    }
  },

  created () {
    this.fetchData('stats/org/20/null/telco', this.processData)
  }


}
</script>
